import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalUserManagementPage } from 'src/app/model/page/group/iag-portal/iag-portal-user-management-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { GroupValidator } from 'src/app/validator/group-validator';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-user-management-page',
  templateUrl: './iag-portal-user-management-page.component.html',
  styleUrls: ['./iag-portal-user-management-page.component.scss']
})
export class IagPortalUserManagementPageComponent implements OnInit {
  iagPortalUserManagementPage: IagPortalUserManagementPage = {} as IagPortalUserManagementPage;
  pageName = 'User management';
  iagPortalUserManagement: any = [];

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-user-management') {
        this.iagPortalUserManagementPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalUserManagementPage.sections = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.mapPageInfo(resIncludes.items);
      this.sharedDataService.addSharedData(this.iagPortalUserManagementPage.banner);
      this.mapSections(resIncludes.includes.Entry);
    });

    // console.log(this.iagPortalUserManagementPage);
  }

  private mapBanner(iagPortalUserManagementPageEntries: Entry<any>[]) {
    iagPortalUserManagementPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.iagPortalUserManagementPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalUserManagementPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalUserManagementPage.banner.url = entry.fields?.url;
      this.iagPortalUserManagementPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalUserManagementPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalUserManagementPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalUserManagementPage.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(iagPortalUserManagementPageEntries: Entry<any>[]) {
    iagPortalUserManagementPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
        this.iagPortalUserManagementPage.sectionsUserManagement = this.iagPortalUserManagementPage.sections.filter((section) => GroupValidator.isUserManagement(section.group));
        this.iagPortalUserManagementPage.sectionsUserManagement.sort((a, b) => a.order - b.order);
        this.iagPortalUserManagementPage.sectionsUserManagementAddingAdmin = this.iagPortalUserManagementPage.sections.filter((section) => GroupValidator.isUserManagementAddingAdmin(section.group));
        this.iagPortalUserManagementPage.sectionsUserManagementAddingAdmin.sort((a, b) => a.order - b.order);
        this.iagPortalUserManagementPage.sectionsUserManagementAddingNewEmployees = this.iagPortalUserManagementPage.sections.filter((section) =>
          GroupValidator.isUserManagementAddingNewEmployees(section.group)
        );
        this.iagPortalUserManagementPage.sectionsUserManagementAddingNewEmployees.sort((a, b) => a.order - b.order);
        this.iagPortalUserManagementPage.sectionsUserManagementPasswordResets = this.iagPortalUserManagementPage.sections.filter((section) =>
          GroupValidator.isUserManagementPasswordResets(section.group)
        );
        this.iagPortalUserManagementPage.sectionsUserManagementPasswordResets.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
        this.iagPortalUserManagementPage.sectionsUserManagementTwoFactor = this.iagPortalUserManagementPage.sections.filter((section) => GroupValidator.isUserManagementTwoFactor(section.group));
        this.iagPortalUserManagementPage.sectionsUserManagementTwoFactor.sort((a: { order: number }, b: { order: number }) => a.order - b.order);
      });
    this.iagPortalUserManagementPage.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {
    let title:any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalUserManagementPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      subBody: entry?.fields?.['subBody'] as string,
      titleColorClass: entry.fields['sectionClass'] as string
    });
    this.iagPortalUserManagement.sectionImageAccordian = this.iagPortalUserManagementPage.sections.filter((section) => section.group === 'user-management-image-accordion');
    this.iagPortalUserManagement.sectionFormViewAccordian = this.iagPortalUserManagementPage.sections.filter((section) => section.group === 'form-view-accordion');
  }
}
